import { FormDrawer, FormDrawerContent, useLaravelCrudEntity } from "@dgs/core";
import { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { companyService } from "../../shared/api/companyService";
import { contactService } from "../../shared/api/contactService";
import { ICompanyFormState, ICompanyUpdateResource } from "../../shared/types";
import { CompanyDrawerFormFields } from "../CompanyDrawerFormFields";

export const CompanyViewUpdateDrawer: FC<{
	company: ICompanyUpdateResource;
	open: boolean;
	handleClose: () => void;
}> = ({ open, handleClose, company }) => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { updateEntity } = useLaravelCrudEntity(
		companyService,
		{
			entityName: t("Company"),
			messages: {
				create: t("Company was saved."),
				update: t("Company was saved."),
				delete: t("Company was deleted."),
			},
		},
		[contactService.keys.baseKey],
	);
	const validate = useCallback(
		(values: ICompanyFormState) => {
			const errors: { [K in keyof ICompanyFormState]?: any } = {};

			if (!values.name) {
				errors.name = t("Required field");
			}
			if (!values.tenants.length) {
				errors.tenants = t("Required field");
			}
			return errors;
		},
		[t],
	);

	return (
		<FormDrawer
			title={t("Edit company")}
			open={open}
			onClose={handleClose}
			initialValues={company}
			validate={validate}
			onSubmit={({ parent, ...values }) => {
				const res = updateEntity(company.id, {
					...values,
					parentId: parent?.id ?? null,
				});
				navigate("/companies");
				return res;
			}}
			renderForm={(props) => (
				<FormDrawerContent {...props}>
					<CompanyDrawerFormFields
						getLabel={(x) =>
							company.archivedByTenants.some((y) => y.id === x.id) ? `(${t("Archived")}) ${x.name}` : x.name
						}
					/>
				</FormDrawerContent>
			)}
		/>
	);
};
